module.exports = __webpack_public_path__ + "img/accepted_light.744039a0.svg";